/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssignmentResponseDto { 
    /**
     * Assignment type
     */
    type: AssignmentResponseDto.TypeEnum;
    /**
     * Assignee ID
     */
    id: string;
    /**
     * Assignee name
     */
    name: string;
}
export namespace AssignmentResponseDto {
    export type TypeEnum = 'user' | 'team' | 'role';
    export const TypeEnum = {
        User: 'user' as TypeEnum,
        Team: 'team' as TypeEnum,
        Role: 'role' as TypeEnum
    };
}


